module.exports = __webpack_public_path__ + "img/icon_integrador_de_dados_hover.96e30b18.png";